module.exports = __webpack_public_path__ + "img/MAC1110_1-1.3fd3c299.jpg";